<template>
    <div>
        <div class="header-wrap">
            <div class="header-logo-wrap">
                <a href="/">
                    <img :src="logoImageUrl" width="211" height="98" class="inline" alt="JAFA Signs">
                    <img :src="buzzImageUrl" width="95" height="108" class="header-logo-buzz" alt="">
                </a>
                <button type="button">
                    <svg class="header_nav-menu" @click="toggleHeaderClass">
                        <use :xlink:href="iconsPublicUrl + '#menu'"></use>
                    </svg>
                </button>
            </div>

            <ul class="header-nav">
                <li v-for="page in navigation"
                    :key="page.url"
                    class="header-nav_item"
                    :class="{ 'active': page.isCurrent || page.isAncestor }">
                    <div class="header-nav_item-inner">
                        <div class="flex justify-between items-center">
                            <div class="flex justify-between items-center w-full">
                                <a :href="page.url"
                                   class="hidden lg:block"
                                   :aria-current="page.isCurrent ? 'page' : undefined"
                                   @click="handleLinkClick($event, page.url)">
                                    {{ page.title }}
                                </a>
                                <button class="button-subnav" @click="toggleSubMenu(page.url)">
                                    <span class="uppercase">{{ page.title }}</span>
                                    <svg class="header_nav-arrow" :class="{ 'open': openMenus[page.url] }">
                                        <use :xlink:href="iconsPublicUrl + '#menu-arrow'"></use>
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div class="header-subnav-wrap-wrap" :class="{ 'header-subnav-open': openMenus[page.url] }">
                            <div class="header-subnav-wrap">
                                <div v-if="page.featuredImage" class="hidden lg:block">
                                    <img :src="page.featuredImage"
                                         :alt="page.title"
                                         class="border border-jafa-green-300 w-72 h-36 object-fill">
                                </div>
                                <div class="lg:w-3/5 lg:px-12">
                                    <h5 class="subnav-page_title">
                                        <a :href="page.url" class="subnav-page_title-link">
                                            {{ page.title }}
                                        </a>
                                    </h5>
                                    <ul v-if="page.title !== 'Contact'" class="header-subnav">
                                        <li v-if="page.title === 'Projects' && projectEntries.length === 0">
                                            <span class="header_subnav-link text-white">No current projects.</span>
                                        </li>
                                        <li v-for="item in (page.title === 'Projects' ? projectEntries : page.children)"
                                            :key="item.url"
                                            :class="{ 'active': item.isCurrent }">
                                            <a :href="item.url"
                                               class="header_subnav-link flex items-center text-lg"
                                               :aria-current="item.isCurrent ? 'page' : undefined">
                                                <img v-if="item.featureIcon && page.title !== 'Projects'"
                                                     alt="featured icon"
                                                     :src="item.featureIcon"
                                                     class="header-subnav-icon" />
                                                {{ item.title }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="subnav-related">
                                    <div class="h-full lg:min-h-40 lg:border-l border-jafa-gray-400">
                                        <div class="lg:pl-10 text-jafa-gray-400">
                                            <!-- <h5 class="subnav_related-title">Related</h5>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

defineOptions({ name: 'NavigationMenu' });

defineProps({
    navigation: {
        type: Array,
        required: true,
    },
    projectEntries: {
        type: Array,
        required: false,
        default: () => [],
    },
    // note: these are included because otherwise vite rewrites the urls
    // such that the images need to be in the build folder
    logoImageUrl: {
        type: String,
        required: true,
    },
    buzzImageUrl: {
        type: String,
        required: true,
    },
});

const iconsPublicUrl = '/images/icons-public.svg';
const openMenus = ref({});
const isMobile = ref(false);

function toggleHeaderClass () {
    const header = document.querySelector('.header');
    if (header) {
        header.classList.toggle('header-mobile-open');
    }
}

function toggleSubMenu (url) {
    openMenus.value[url] = !openMenus.value[url];
}

function handleLinkClick (event, url) {
    if (isMobile.value) {
        event.preventDefault();
        toggleSubMenu(url);
    }
}

function checkMobile () {
    isMobile.value = window.innerWidth <= 768;
    const header = document.querySelector('.header');
    if (header) {
        header.classList.remove('header-mobile-open');
    }
    openMenus.value = {};
}

onMounted(() => {
    checkMobile();
    window.addEventListener('resize', checkMobile);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', checkMobile);
});
</script>
